import getFocusableElements from './getFocusableElements';

const getFirstFocusableElement = (parentElement, options) => {
  if (!parentElement) {
    return null;
  }

  const focusableElements = getFocusableElements(parentElement, options);

  if (focusableElements.length) {
    return focusableElements[0];
  }

  return null;
};

export default getFirstFocusableElement;
